export const getFileUrl = (fileUrl) => {
  return fileUrl?.includes('https://mymathscloud.ams3.digitaloceanspaces.com/')
    ? unescape(fileUrl.replace('https://mymathscloud.ams3.digitaloceanspaces.com/', ''))
    : fileUrl;
};
